import $ from "jquery";
window.jQuery = $;
window.$ = $;

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/object-fit/ls.object-fit";

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import sal from "sal.js";

import { windowWatcher } from "./components/window-watcher";
import { logo } from "./components/logo";
import { nav } from "./components/nav";
import { menucards } from "./components/menucards";
import { toggleSection } from "./components/toggle-section";
import { overlay } from "./components/overlay";
// import { gallery } from "./components/gallery";

// import { collapsibleText } from "./components/collapsible-text";
// import { collapsibleSections } from "./components/collapsible-sections";
// import { filters } from "./components/filters";
import { anchorLinks } from "./components/anchor-links";

window.main = window.main || {};

const $body = $("body");

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;
let isOverlayToggled = false;

function checks() {

  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
  
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

}

function setupPlugins() {

  function initSwup() {

    const options = {
      animateHistoryBrowsing: true,
      containers: ["#main"],
      plugins: [
        new SwupPreloadPlugin(),
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });

  }

  initSwup();

}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {

  sal({
    threshold: 0.1,
    once: true,
  });

  document.body.setAttribute("data-menu-open", "false");
  document.body.setAttribute("data-overlay-open", "false");
  document.body.classList.remove("no-scroll");

  isNavToggled = false;
  isOverlayToggled = false;

  nav(isNavToggled);
  overlay(isOverlayToggled);
  menucards();
  toggleSection();
  anchorLinks();


  
}

function init() {

  sal({
    threshold: 0.1,
    once: true,
  });
  
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  windowWatcher();
  logo(isHomepage, isTouchDevice);
  nav(isNavToggled);
  overlay(isOverlayToggled);
  menucards();
  toggleSection();

  anchorLinks();

}

checks();
setupPlugins();
init();
